import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplateCabecalho from '@/shared/http/repositories/business/qmaTemplateHeader'
import { loading } from '@/shared/utils/UIHelper'
import IconCampoPequeno from '../../../../../../../../../static/img/qma/IconCampoPequeno.svg'
import IconData from '../../../../../../../../../static/img/qma/IconData.svg'
import IconNumero from '../../../../../../../../../static/img/qma/IconNumero.svg'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'
import draggable from 'vuedraggable'

export default {
  name: 'headerTemplate',
  props: ['templateid', 'novosItensTableCabecalho'],
  components: {draggable},
  mixins: [ActionsForm],
  data () {
    return {
      dataTemplateQMACabecalho: [],
      dataEdicoesCancelar: [],
      dataItensChecadoEdicoesCancelar: [],
      dataEdicoesInativoCancelar: [],
      dataEdicoesAtivoCancelar: [],
      liberaExclusaoEdicao: false,
      imgTexto: IconCampoPequeno,
      imgData: IconData,
      notFound: ImageNotFound,
      imgNumero: IconNumero
    }
  },
  watch: {
    novosItensTableCabecalho (value) {
      this.dataTemplateQMACabecalho.push(...value)
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onDragChange (event) {
      // Identifica a posição inicial e final do item movido
      if (event.moved) {
        // Identifica a posição inicial e final do item movido
        const oldIndex = event.moved.oldIndex // Índice original
        const newIndex = event.moved.newIndex // Índice final
        this.dataTemplateQMACabecalho.sort((a, b) => a.nivelPrioridade - b.nivelPrioridade)

        // Referência aos dois itens que trocaram de posição
        const itemMovido = this.dataTemplateQMACabecalho[newIndex]
        const itemSubstituido = this.dataTemplateQMACabecalho[oldIndex]

        // Armazena o valor original de nivelPrioridade do itemMovido
        const originalNivelPrioridadeMovido = itemMovido.nivelPrioridade

        // Atualiza os valores de nivelPrioridade e outras propriedades
        itemMovido.nivelPrioridade = itemSubstituido.nivelPrioridade
        itemMovido.edicao = true
        itemMovido.descricaoEdicao = 'AG. ENVIO - EDIÇÃO NÍVEL PRIORIDADE'
        itemMovido.colorStatus = 'rgb(255, 216, 187)'
        itemMovido.colorFonte = 'rgb(188, 72, 7)'

        itemSubstituido.nivelPrioridade = originalNivelPrioridadeMovido
        itemSubstituido.edicao = true
        itemSubstituido.descricaoEdicao = 'AG. ENVIO - EDIÇÃO NÍVEL PRIORIDADE'
        itemSubstituido.colorStatus = 'rgb(255, 216, 187)'
        itemSubstituido.colorFonte = 'rgb(188, 72, 7)'

        // Criação dos objetos para emissão
        const movido = {
          id: itemMovido.id,
          nivelPrioridade: itemMovido.nivelPrioridade
        }

        const substituido = {
          id: itemSubstituido.id,
          nivelPrioridade: itemSubstituido.nivelPrioridade
        }

        // Cria o array e adiciona os objetos
        const Nivelajustado = []
        Nivelajustado.push(substituido, movido)

        // Emite o evento com os dados atualizados
        this.$emit('AlterandoNivelPrioridadeCabecalho', Nivelajustado)

        this.dataTemplateQMACabecalho.sort((a, b) => a.nivelPrioridade - b.nivelPrioridade)
      }
    },
    addcabecalho () {
      this.$emit('popUpCabecalho', true)
    },
    onLoad () {
      loading.push()
      qmaTemplateCabecalho.GetQMATemplateListaCabecalho(this.templateid)
        .then((Response) => {
          loading.pop()
          this.dataTemplateQMACabecalho = Response.data.data
        })
    },

    excluirItemCabecalho (id) {
      this.AtivacaoInativacao('AG. ENVIO - EXCLUSÃO', true, false, id, 'rgb(136, 22, 22)', 'rgb(255, 205, 205)', true)
    },

    CheckboxAtivacaoInativacao (id, status) {
      if (status !== 1) {
        this.AtivacaoInativacao('AG. ENVIO - ATIVAÇÃO', false, true, id, 'rgb(28, 98, 40)', 'rgb(203, 233, 207)')
      } else {
        this.AtivacaoInativacao('AG. ENVIO - INATIVAÇÃO', true, false, id, 'rgb(136, 22, 22)', 'rgb(255, 205, 205)')
      }
    },
    AtivacaoInativacao (descricao, inativacao, ativacao, id, fonte, status, exclusao = false) {
      const item = this.dataTemplateQMACabecalho.find((item) => item.id === id)
      item.edicao = true
      item.status = inativacao ? 0 : 1
      item.descricaoEdicao = descricao
      item.colorStatus = status
      item.ativo = ativacao
      item.inativo = inativacao
      item.colorFonte = fonte

      if (exclusao) {
        item.status = -1
      }

      if (ativacao === true) {
        this.$emit('addEdicaoAtivacao', id)
      }
      if (inativacao === true) {
        this.$emit('addEdicaoInativacao', id, exclusao)
      }
    },
    CheckExclusaoEdicao (id, value) {
      for (let i = 0; i < this.dataTemplateQMACabecalho.length; i++) {
        if (this.dataTemplateQMACabecalho[i].id === id) {
          this.dataTemplateQMACabecalho[i].check = value
        }
      }
    },

    verificaCamposCheck () {
      let existeCheckTrue = this.dataTemplateQMACabecalho.some(item => item.check === true)

      if (existeCheckTrue === false) {
        this.liberaExclusaoEdicao = false
      } else {
        this.liberaExclusaoEdicao = true
      }
      this.$emit('liberaButonEdicaoExclusao', this.liberaExclusaoEdicao)
    },
    AdicionarItenParaExclusaoDaEdicao (id) {
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.dataEdicoesCancelar = this.dataEdicoesCancelar.filter(item => item !== id.id)
        this.dataItensChecadoEdicoesCancelar = this.dataItensChecadoEdicoesCancelar.filter(item => item !== id.id)

        this.CheckExclusaoEdicao(id.id, false)
        this.verificaCamposCheck()
      } else {
        div.classList.add('clicked')

        if (id.add === true) {
          if (this.dataEdicoesCancelar !== null && this.dataEdicoesCancelar !== undefined && this.dataEdicoesCancelar.length > 0) {
            this.dataEdicoesCancelar.push(id.id)
            this.dataItensChecadoEdicoesCancelar.push(id.id)
          } else {
            this.dataEdicoesCancelar[0] = id.id
            this.dataItensChecadoEdicoesCancelar[0] = id.id
          }
        }

        if (id.inativo === true) {
          if (this.dataEdicoesInativoCancelar !== null && this.dataEdicoesInativoCancelar !== undefined && this.dataEdicoesInativoCancelar.length > 0) {
            this.dataEdicoesInativoCancelar.push(id.id)
          } else {
            this.dataEdicoesInativoCancelar[0] = id.id
          }
        }

        if (id.ativo === true) {
          if (this.dataEdicoesAtivoCancelar !== null && this.dataEdicoesAtivoCancelar !== undefined && this.dataEdicoesAtivoCancelar.length > 0) {
            this.dataEdicoesAtivoCancelar.push(id.id)
          } else {
            this.dataEdicoesAtivoCancelar[0] = id.id
          }
        }

        this.CheckExclusaoEdicao(id.id, true)
        this.verificaCamposCheck()
      }
    },
    removerItemTable () {
      for (let i = 0; i < this.dataEdicoesCancelar.length; i++) {
        let idCancelar = this.dataEdicoesCancelar[i]

        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMACabecalho.length; j++) {
          if (this.dataTemplateQMACabecalho[j].id === idCancelar) {
            this.dataTemplateQMACabecalho.splice(j, 1)
            this.verificaCamposCheck()
            break
          }
        }
      }
      this.dataEdicoesCancelar = []
    },
    removerEdicoesInativacaoTable () {
      for (let i = 0; i < this.dataEdicoesInativoCancelar.length; i++) {
        let idCancelarInativacao = this.dataEdicoesInativoCancelar[i]
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMACabecalho.length; j++) {
          if (this.dataTemplateQMACabecalho[j].id === idCancelarInativacao) {
            this.dataTemplateQMACabecalho[j].status = 1
            this.dataTemplateQMACabecalho[j].descricaoEdicao = ''
            this.dataTemplateQMACabecalho[j].inativo = false
            this.dataTemplateQMACabecalho[j].edicao = false
            this.dataTemplateQMACabecalho[j].check = false
            this.$emit('removerExclusao', idCancelarInativacao)
            this.verificaCamposCheck()
            break
          }
        }
      }
    },
    removerEdicoesInativacaoAtivacaoRetonarCasoTenhaItemEdicaoTable () {
      // Encontra o índice do objeto a ser removido
      for (let j = 0; j < this.dataTemplateQMACabecalho.length; j++) {
        if (this.dataTemplateQMACabecalho[j].inativo === true || this.dataTemplateQMACabecalho[j].ativo === true || this.dataTemplateQMACabecalho[j].edicao === true) {
          return true
        }
      }
    },
    removerEdicoesAtivacaoTable () {
      for (let i = 0; i < this.dataEdicoesAtivoCancelar.length; i++) {
        let idCancelarInativacao = this.dataEdicoesAtivoCancelar[i]
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMACabecalho.length; j++) {
          if (this.dataTemplateQMACabecalho[j].id === idCancelarInativacao) {
            this.dataTemplateQMACabecalho[j].status = 0
            this.dataTemplateQMACabecalho[j].descricaoEdicao = ''
            this.dataTemplateQMACabecalho[j].ativo = false
            this.dataTemplateQMACabecalho[j].edicao = false
            this.dataTemplateQMACabecalho[j].check = false
            this.verificaCamposCheck()
            break
          }
        }
      }
    },
    limparItensEdicao () {
      if (this.dataItensChecadoEdicoesCancelar.length > 0) {
        this.$emit('removerItensparaEdicaoExclusao', this.dataItensChecadoEdicoesCancelar)
      }
      if (this.dataEdicoesAtivoCancelar.length > 0) {
        this.$emit('removerItensparaEdicaoAtivacaoCabecalhoExclusao', this.dataEdicoesAtivoCancelar)
      }
      if (this.dataEdicoesInativoCancelar.length > 0) {
        this.$emit('removerItensparaEdicaoInativacaoExclusao', this.dataEdicoesInativoCancelar)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/headerTemplate/headerTemplate.js